import { FC, HTMLAttributes } from "react";
import Text from "../../../../../components/Text";
import Stat from "../../../../../components/Text/Stat";
import styles from "./StatsDayCell.module.scss";

interface StatsDayCellProps extends HTMLAttributes<HTMLDivElement> {
    dayNumber: number;
    value?: number;
}

const StatsDayCell: FC<StatsDayCellProps> = ({
    dayNumber,
    value,
    className,
    ...rest
}) => {
    return (
        <div {...rest} className={className}>
            <div className={styles.customDayCellContent}>
                <div className={styles.topCase}>
                    <Text className={styles.dayNumber} variant="body">
                        {dayNumber}
                    </Text>
                    {value !== undefined && (
                        <Stat
                            variant="body-bold"
                            className={styles.total}
                            type="currency"
                            decimals={0}
                        >
                            {value}
                        </Stat>
                    )}
                </div>
            </div>
        </div>
    );
};

export default StatsDayCell;
